/* eslint-disable sort-keys */
import APP_ICON from '../../../../../assets/imagens/cancelamento-app.svg'
import KITS_ICON from '../../../../../assets/imagens/cancelamento-kits.svg'
import LOJA_ICON from '../../../../../assets/imagens/cancelamento-loja.svg'

export const TITULO_NOVIDADES_TAG = 'Mas antes, olha só as novidades da TAG:'

export const TITULO_BENEFICIOS = 'Benefícios exclusivos de nossos associados'

export const DESCRICAO_BENEFICIOS = 'Associados têm desconto nos produtos da livraria da TAG e acesso exclusivo aos kits passados e ao aplicativo do clube!'

export const PERGUNTA_SEGUIR_CANCELAMENTO = 'Você tem certeza de que deseja seguir com a solicitação de cancelamento?'

export const BOTAO_CANCELAR_ASSINATURA = 'Preciso cancelar minha assinatura'

export const BOTAO_CANCELAR_ASSINATURA_MOBILE = 'Seguir com o cancelamento'

export const BOTAO_PERMANECER = 'Quero continuar no clube'

export const TITULO_MODAL = 'Que notícia ótima!'

export const DESCRICAO_MODAL = 'Ficamos muito contentes que você permanecerá vivendo experiências literárias exclusivas com a gente. Desejamos ótimas leituras!'

export const ACAO_BOTAO_MODAL = 'Voltar para home'

export const TEXTO_DUVIDAS = 'Dúvidas ou sugestões? Mande e-mail para'

export const ICONS = [
  {
    'descricao': 'App exclusivo',
    'icon': APP_ICON,
    'titulo': 'app'
  },
  {
    'descricao': 'Descontos na livraria da TAG',
    'icon': LOJA_ICON,
    'titulo': 'loja'
  },
  {
    'descricao': 'Compra de kits passados',
    'icon': KITS_ICON,
    'titulo': 'kits'
  }
]

export const showTextoMulta = valor => `Lembramos que os cancelamentos de planos anuais que ainda estão vigentes
  serão realizados mediante pagamento de uma multa, no valor de uma caixinha (R$ ${valor.toString().replace( '.', ',' )}).
  Se você está cancelando para receber a última caixinha do seu plano, não se preocupe, pois a cobrança da multa não será realizada.`
